/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Lp pair data
 */
export interface LpPairData {
  /**
   * Pair ID.
   */
  pairId: number;
  /**
   * Position in buy rating for existing pairs. Null - data not available.
   */
  ratingPositionBuy?: number;
  /**
   * Position in sell rating for existing pairs. Null - data not available.
   */
  ratingPositionSell?: number;
  /**
   * Spread BPS. Null - data not available.
   */
  spreadBps?: number;
  /**
   * True, if buy order can be executed partially.
   */
  canBeExecutedPartiallyBuy?: boolean;
  /**
   * True, if sell order can be executed partially
   */
  canBeExecutedPartiallySell?: boolean;
}
